import { IconTypes } from './Icons'

export default function SmileEmoji({
  color = '#ffffff',
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
}: Readonly<IconTypes>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      style={{
        width: '1em',
        height: '1em',
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      className={className}
    >
      <g opacity='0.6'>
        <path
          d='M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z'
          fill={color}
        />
        <path
          d='M14.8294 14.8278C14.4639 15.1922 14.0322 15.4834 13.5574 15.6858C12.7027 16.0467 11.7492 16.0993 10.8599 15.8349C9.9707 15.5704 9.20097 15.0051 8.68241 14.2358L7.02441 15.3548C7.45685 15.993 8.00701 16.5428 8.64541 16.9748C9.29507 17.4142 10.025 17.721 10.7934 17.8778C11.5902 18.0404 12.4116 18.0404 13.2084 17.8778C13.9768 17.7208 14.7066 17.414 15.3564 16.9748C15.6694 16.7628 15.9684 16.5168 16.2424 16.2438C16.5144 15.9728 16.7624 15.6728 16.9764 15.3548L15.3184 14.2358C15.1747 14.4483 15.0109 14.6466 14.8294 14.8278Z'
          fill={color}
        />
        <path
          d='M15.493 11.986C16.3176 11.986 16.986 11.3176 16.986 10.493C16.986 9.66844 16.3176 9 15.493 9C14.6684 9 14 9.66844 14 10.493C14 11.3176 14.6684 11.986 15.493 11.986Z'
          fill={color}
        />
        <path
          d='M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9C7.67157 9 7 9.67157 7 10.5C7 11.3284 7.67157 12 8.5 12Z'
          fill={color}
        />
      </g>
    </svg>
  )
}
